/**
 * PlaylistMenuStaticTextScope — single, lifted provider for the
 * `profilePlaylistMenuOptions` static-text slice.
 *
 * `CustomMenu` and `SystemMenu` used to each mount their own
 * `connectStaticText` HOC + `<StaticTextProvider>`. With ~15 custom + system
 * rows per library, that meant ~15 Redux `react-redux` subscriptions and 15
 * providers in the tree, all serving the same single-locale Map. This scope
 * mounts the HOC + provider **once** above the row-rendering region in
 * `ProfileMyPlaylists`; both menu variants then read from the nearest
 * enclosing provider via `useTranslatedText` (Community CLAUDE.md §i18n
 * wiring rule 2/4).
 *
 * Sibling providers in the same subtree (`playlistRowHeader`,
 * `deletePlaylistConfirmModal`, `playlistShareButton`, etc.) are unaffected
 * because each of those components keeps its own self-connected
 * `<StaticTextProvider>` — `useTranslatedText` always reads from the
 * nearest enclosing provider.
 */

import React from 'react'
import { connect as connectStaticText } from '../../../../StaticText/connect'
import {
  StaticTextProvider,
  InternationalStrings,
} from '../../../../StaticText/StaticTextContext'

interface OuterProps {
  children: React.ReactNode
}

interface InnerProps extends OuterProps {
  staticText: InternationalStrings
}

function PlaylistMenuStaticTextScopeInner ({ staticText, children }: InnerProps) {
  return (
    <StaticTextProvider staticText={staticText}>
      {children}
    </StaticTextProvider>
  )
}

const PlaylistMenuStaticTextScope: React.ComponentType<OuterProps> = (
  connectStaticText({ storeKey: 'profilePlaylistMenuOptions' })(
    PlaylistMenuStaticTextScopeInner,
  )
)

export default PlaylistMenuStaticTextScope
